<form [formGroup]="feedbackForm">
  <div class="flex flex-col items-center gap-4">
    <h4>{{ title }}</h4>
    <div
      class="flex w-fit gap-6 rounded border border-pl-black p-4"
      [ngClass]="{
        'bg-pl-gray-300 text-pl-gray-500': isDisabled
      }"
    >
      <pl-icon
        *ngFor="let indexStar of stars"
        [name]="PlIcon.star"
        class="h-10 w-10 cursor-pointer"
        [class.pointer-events-none]="isDisabled"
        [ngClass]="
          indexHoveredStar() !== -1
            ? indexStar <= indexHoveredStar()
              ? 'text-pl-yellow'
              : 'text-pl-gray-500'
            : indexStar <= feedbackForm.controls[FormControlName.rating].value
              ? 'text-pl-yellow'
              : 'text-pl-gray-500'
        "
        (mouseenter)="setIndexMouseHovered(indexStar)"
        (mouseleave)="setIndexMouseHovered(-1)"
        (click)="selectStar(indexStar)"
      />
    </div>
  </div>

  <div *ngIf="feedbackForm.controls[FormControlName.rating].value !== -1" class="mt-4 flex flex-col gap-4">
    <pl-textarea
      #plTextArea
      [label]="labelFeedbackText"
      [placeholder]="placeholderFeedbackText"
      [isDisabled]="isDisabled"
      [isFormSubmitted]="isFormSubmitted"
      [formControlName]="FormControlName.feedbackText"
    />
  </div>
</form>
